<div class="bar-chart-container ion-text-center">
  <canvas baseChart #baseBarChart chartType="pie" [data]="chartDatas" [colors]="chartColor" [labels]="chartLabels" [options]="chartOptions" [legend]="isShowLegend" [plugins]="chartPlugins"></canvas>
</div>
